/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Embed_Captions_DescInputs */

const en_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add 608/708 closed caption track`)
};

const fr_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une piste de sous-titres 608/708`)
};

const de_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge die Untertitelspur 608/708 hinzu.`)
};

const it_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi traccia sottotitoli 608/708`)
};

const ru_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить дорожку субтитров 608/708`)
};

const es_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar pista de subtítulos 608/708`)
};

const zh_cn2_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加 608/708 隐藏式字幕轨道`)
};

const ja_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608/708クローズドキャプショントラックを追加`)
};

const hi_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608/708 क्लोज्ड कैप्शन ट्रैक जोड़ें`)
};

const pt_pt2_file_export_embed_captions_desc = /** @type {(inputs: File_Export_Embed_Captions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar faixa de legenda oculta 608/708`)
};

/**
* | output |
* | --- |
* | "Add 608/708 closed caption track" |
*
* @param {File_Export_Embed_Captions_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_embed_captions_desc = /** @type {((inputs?: File_Export_Embed_Captions_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Embed_Captions_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_embed_captions_desc(inputs)
	if (locale === "de") return de_file_export_embed_captions_desc(inputs)
	if (locale === "it") return it_file_export_embed_captions_desc(inputs)
	if (locale === "ru") return ru_file_export_embed_captions_desc(inputs)
	if (locale === "es") return es_file_export_embed_captions_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_embed_captions_desc(inputs)
	if (locale === "ja") return ja_file_export_embed_captions_desc(inputs)
	if (locale === "hi") return hi_file_export_embed_captions_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_embed_captions_desc(inputs)
	return en_file_export_embed_captions_desc(inputs)
});